import { render, staticRenderFns } from "./btnL.vue?vue&type=template&id=8d97e6d8&scoped=true&"
import script from "./btnL.vue?vue&type=script&lang=js&"
export * from "./btnL.vue?vue&type=script&lang=js&"
import style0 from "./btnL.vue?vue&type=style&index=0&id=8d97e6d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d97e6d8",
  null
  
)

export default component.exports